import React from "react"
import PropTypes from "prop-types"

export default function NavigationMenuIcon({
  className,
  color,
  width,
  height,
  isOpen,
  onClick,
}) {
  if (isOpen) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "40"}
        height={height || "40"}
        fill="none"
        viewBox="0 0 40 40"
        className={className}
        onClick={onClick}
      >
        <mask
          id="path-1-outside-1-ksdfgkljsdgh"
          width="20"
          height="20"
          x="10"
          y="10"
          fill={color || "#000"}
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M10 10H30V30H10z"></path>
          <path
            fillRule="evenodd"
            d="M11.72 11l.707.707L20 19.28l7.573-7.573.707-.707.013.013.694.694.013.013-.707.707L20.72 20l7.573 7.573.707.707-.013.013-.694.694-.013.013-.707-.707L20 20.72l-7.573 7.573-.707.707-.013-.013-.694-.694L11 28.28l.707-.707L19.28 20l-7.573-7.573L11 11.72l.013-.013.694-.694.013-.013z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill={color || "#000"}
          fillRule="evenodd"
          d="M11.72 11l.707.707L20 19.28l7.573-7.573.707-.707.013.013.694.694.013.013-.707.707L20.72 20l7.573 7.573.707.707-.013.013-.694.694-.013.013-.707-.707L20 20.72l-7.573 7.573-.707.707-.013-.013-.694-.694L11 28.28l.707-.707L19.28 20l-7.573-7.573L11 11.72l.013-.013.694-.694.013-.013z"
          clipRule="evenodd"
        ></path>
        <path
          fill={color || "#000"}
          d="M12.427 11.707l.177-.177-.177.177zM11.72 11l.177-.177-.177-.177-.177.177.177.177zM20 19.28l-.177.177.177.177.177-.177L20 19.28zm7.573-7.573l-.177-.177.177.177zM28.28 11l.177-.177-.177-.177-.177.177.177.177zm.013.013l-.177.177.177-.177zm.694.694l-.177.177.177-.177zm.013.013l.177.177.177-.177-.177-.177-.177.177zm-.707.707l-.177-.177.177.177zM20.72 20l-.177-.177-.177.177.177.177.177-.177zM29 28.28l.177.177.177-.177-.177-.177-.177.177zm-.013.013l-.177-.177.177.177zM28.28 29l-.177.177.177.177.177-.177L28.28 29zm-.707-.707l.177-.177-.177.177zM20 20.72l.177-.177-.177-.177-.177.177.177.177zm-7.573 7.573l.177.177-.177-.177zM11.72 29l-.177.177.177.177.177-.177L11.72 29zm-.013-.013l-.177.177.177-.177zm-.694-.694l-.177.177.177-.177zM11 28.28l-.177-.177-.177.177.177.177.177-.177zm.707-.707l-.177-.177.177.177zM19.28 20l.177.177.177-.177-.177-.177-.177.177zm-7.573-7.573l-.177.177.177-.177zM11 11.72l-.177-.177-.177.177.177.177.177-.177zm.013-.013l.177.177-.177-.177zm.694-.694l.177.177-.177-.177zm.897.517l-.707-.707-.354.354.707.707.354-.354zm7.573 7.573l-7.573-7.573-.354.354 7.573 7.573.354-.354zm7.22-7.573l-7.574 7.573.354.354 7.573-7.573-.354-.354zm.706-.707l-.707.707.354.354.707-.707-.354-.354zm.367.013l-.013-.013-.354.354.013.013.354-.354zm.694.694l-.694-.694-.354.354.694.694.354-.354zm.013.013l-.013-.013-.354.354.013.013.354-.354zm-.707 1.06l.707-.706-.354-.354-.707.707.354.354zm-7.573 7.574l7.573-7.573-.354-.354-7.573 7.573.354.354zm7.573 7.22l-7.573-7.574-.354.354 7.573 7.573.354-.354zm.707.706l-.707-.707-.354.354.707.707.354-.354zm-.013.367l.013-.013-.354-.354-.013.013.354.354zm-.694.694l.694-.694-.354-.354-.694.694.354.354zm-.013.013l.013-.013-.354-.354-.013.013.354.354zm-1.06-.707l.706.707.354-.354-.707-.707-.354.354zm-7.574-7.573l7.573 7.573.354-.354-7.573-7.573-.354.354zm-7.22 7.573l7.574-7.573-.354-.354-7.573 7.573.354.354zm-.706.707l.707-.707-.354-.354-.707.707.354.354zm-.367-.013l.013.013.354-.354-.013-.013-.354.354zm-.694-.694l.694.694.354-.354-.694-.694-.354.354zm-.013-.013l.013.013.354-.354-.013-.013-.354.354zm.707-1.06l-.707.706.354.354.707-.707-.354-.354zm7.573-7.574l-7.573 7.573.354.354 7.573-7.573-.354-.354zm-7.573-7.22l7.573 7.574.354-.354-7.573-7.573-.354.354zm-.707-.706l.707.707.354-.354-.707-.707-.354.354zm.013-.367l-.013.013.354.354.013-.013-.354-.354zm.694-.694l-.694.694.354.354.694-.694-.354-.354zm.013-.013l-.013.013.354.354.013-.013-.354-.354z"
          mask="url(#path-1-outside-1)"
        ></path>
      </svg>
    )
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "41"}
      height={height || "40"}
      fill="none"
      viewBox="0 0 41 40"
      className={className}
      onClick={onClick}
    >
      <mask
        id="path-1-outside-1-gsdfnghfjkbl"
        width="26"
        height="17"
        x="7.473"
        y="11"
        fill={color || "#000"}
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M7.473 11H33.473V28H7.473z"></path>
        <path
          fillRule="evenodd"
          d="M31.473 12h1v1h-20.97v-1h19.97zm0 7h1v1H8.508v-1h22.965zm1 7H14.499v1h17.974v-1z"
          clipRule="evenodd"
        ></path>
      </mask>
      <path
        fill={color || "#000"}
        fillRule="evenodd"
        d="M31.473 12h1v1h-20.97v-1h19.97zm0 7h1v1H8.508v-1h22.965zm1 7H14.499v1h17.974v-1z"
        clipRule="evenodd"
      ></path>
      <path
        fill={color || "#000"}
        d="M32.473 12v-.25h.25V12h-.25zm0 1h.25v.25h-.25V13zm-20.97 0v.25h-.25V13h.25zm0-1h-.25v-.25h.25V12zm20.97 7v-.25h.25V19h-.25zm0 1h.25v.25h-.25V20zM8.508 20v.25h-.25V20h.25zm0-1h-.25v-.25h.25V19zm23.965 7v-.25h.25V26h-.25zm-17.974 0h-.25v-.25h.25V26zm0 1v.25h-.25V27h.25zm17.974 0h.25v.25h-.25V27zm0-14.75h-1v-.5h1v.5zm-.25.75v-1h.5v1h-.5zm-.75-.25h1v.5h-1v-.5zm-18.97 0h18.97v.5h-18.97v-.5zm-1 0h1v.5h-1v-.5zm.25-.75v1h-.5v-1h.5zm.75.25h-1v-.5h1v.5zm18.97 0h-18.97v-.5h18.97v.5zm1 7h-1v-.5h1v.5zm-.25.75v-1h.5v1h-.5zm-.75-.25h1v.5h-1v-.5zm-21.965 0h21.965v.5H9.508v-.5zm-1 0h1v.5h-1v-.5zm.25-.75v1h-.5v-1h.5zm.75.25h-1v-.5h1v.5zm21.965 0H9.508v-.5h21.965v.5zm0 6.5h1v.5h-1v-.5zm-15.974 0h15.974v.5H15.499v-.5zm-1 0h1v.5h-1v-.5zM14.25 27v-1h.5v1h-.5zm1.25.25h-1v-.5h1v.5zm15.974 0H15.499v-.5h15.974v.5zm1 0h-1v-.5h1v.5zm.25-1.25v1h-.5v-1h.5z"
        mask="url(#path-1-outside-1)"
      ></path>
    </svg>
  )
}

NavigationMenuIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
}
